import axios from 'axios';
import Vue from 'vue'

export default {

    findItems (page, pageSize,selectedBrand,reference, position) {
        return axios.get('/api/items/list', { params: {page: page, pageSize: pageSize,selectedBrand:selectedBrand,reference:reference, position:position} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findItemsByOEM (page, pageSize,selectedBrand,oemReference) {
        return axios.get('/api/items/oems/list', { params: {page: page, pageSize: pageSize,selectedBrand:selectedBrand,oemReference:oemReference} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findItemsByVIN (page, pageSize,selectedBrand,vin) {
        return axios.get('/api/items/vin/list', { params: {page: page, pageSize: pageSize,selectedBrand:selectedBrand,vin:vin} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findItemsByVehicules (page, pageSize,selectedBrand,selectedManufacturer,selectedVehiculeModel,selectedMotorizationType, position) {
        return axios.get('/api/items/vehicules/list', { params: {page: page, pageSize: pageSize,selectedBrand:selectedBrand,manufacturer:selectedManufacturer,model:selectedVehiculeModel,vehicule:selectedMotorizationType, position:position} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getItemsOEMs (itemId) {
        return axios.get('/api/items/oems/', { params: {itemId:itemId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getItemsManufacturers (itemId) {
        return axios.get('/api/items/manufacturers/list', { params: {itemId:itemId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getManufacturers () {
        return axios.get('/api/items/manufacturers/')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getModels (manufacturerId) {
        return axios.get('/api/items/models/', { params: {manufacturerId:manufacturerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getVehicules (modelId) {
        return axios.get('/api/items/vehicules/', { params: {modelId:modelId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSimilairItems (page, pageSize,itemId) {
        return axios.get('/api/items/similair/', { params: {page: page, pageSize: pageSize,itemId:itemId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSimilairItemsByRefCatalog (refCatalog) {
        return axios.get('/api/items/similair-by-ref-catalog/', { params: {refCatalog:refCatalog} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },



    getCategories (level, customerId, parentId, page, pageSize) {
        return axios.get('/api/items/categories', { params: { level: level, customerId: customerId, parentId: parentId, page: page, pageSize: pageSize } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getSupplierItems (supplierId) {
        return axios.get('/api/items/list',{params: {supplierId: supplierId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    }, 

    getMaxFileSize() {
        return axios.get('/api/items/size')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getAllBrands(){
        return axios.get('/api/items/brand/all')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


}

